<template>
	<v-app>
		<v-main>
			<v-container fluid class="portal-login-bg fill-height">
				<v-row align="center" justify="center">
					<v-col cols="12" sm="6" md="4" lg="3">
						<v-card class="elevation-12 rounded-lg">
							<v-card-title class="primary white--text justify-center py-6">
								<div class="text-center">
									<v-icon dark x-large class="mb-2">mdi-lock-reset</v-icon>
									<div class="text-h5 font-weight-bold">Cambio Password</div>
									<div class="text-body-2 mt-1">Imposta una nuova password per continuare</div>
								</div>
							</v-card-title>
							<v-card-text class="pa-6">
								<v-alert v-if="error" type="error" dense outlined class="mb-4">
									{{ error }}
								</v-alert>
								<v-alert v-if="success" type="success" dense outlined class="mb-4">
									{{ success }}
								</v-alert>
								<v-form ref="form" @submit.prevent="changePassword" lazy-validation>
									<v-text-field
										v-model="newPassword"
										label="Nuova Password"
										prepend-icon="mdi-lock"
										:type="showNew ? 'text' : 'password'"
										:append-icon="showNew ? 'mdi-eye-off' : 'mdi-eye'"
										@click:append="showNew = !showNew"
										:rules="passwordRules"
										outlined
										dense
										class="mb-2"
									></v-text-field>
									<v-text-field
										v-model="confirmPassword"
										label="Conferma Password"
										prepend-icon="mdi-lock-check"
										:type="showConfirm ? 'text' : 'password'"
										:append-icon="showConfirm ? 'mdi-eye-off' : 'mdi-eye'"
										@click:append="showConfirm = !showConfirm"
										:rules="confirmRules"
										outlined
										dense
									></v-text-field>
									<portal-password-requirements :password="newPassword" :policy="policy"></portal-password-requirements>
									<v-btn
										type="submit"
										color="primary"
										block
										large
										:loading="loading"
										class="mt-2"
									>
										Cambia Password
									</v-btn>
								</v-form>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</v-main>
	</v-app>
</template>

<script>
import PortalPasswordRequirements from './PortalPasswordRequirements'
import { DEFAULT_PORTAL_PASSWORD_POLICY, buildPasswordRules, fetchPortalPasswordPolicy, firstValidationError } from './portalPasswordPolicy'

export default {
	name: 'PortalChangePassword',
	components: {
		PortalPasswordRequirements
	},
	data() {
		return {
			newPassword: '',
			confirmPassword: '',
			showNew: false,
			showConfirm: false,
			loading: false,
			error: null,
			success: null,
			policy: Object.assign({}, DEFAULT_PORTAL_PASSWORD_POLICY),
			confirmRules: [
				v => !!v || 'Conferma password obbligatoria',
				v => v === this.newPassword || 'Le password non coincidono'
			]
		}
	},
	computed: {
		passwordRules() {
			return buildPasswordRules(this.policy)
		}
	},
	async created() {
		this.$store.dispatch('PORTAL_RESTORE_SESSION')
		this.policy = await fetchPortalPasswordPolicy(this.axios)
	},
	methods: {
		async changePassword() {
			if (!this.$refs.form.validate()) return

			this.loading = true
			this.error = null
			this.success = null

			try {
				// Sempre l'endpoint autenticato: il login restituisce il token anche
				// quando il cambio password e' obbligatorio, e con la verifica in due
				// passaggi quel token e' l'unico ottenuto passando dall'OTP.
				const resp = await this.axios({
					url: 'portal/change-password',
					method: 'POST',
					data: {
						password: this.newPassword,
						password_confirmation: this.confirmPassword
					},
					// l'errore di validazione e' mostrato nel form
					silentValidation: true
				})

				if (resp.data.success) {
					this.$store.commit('PORTAL_CLEAR_FORCE_PASSWORD')
					this.success = 'Password cambiata con successo'
					setTimeout(() => {
						this.$router.push('/portal')
					}, 1500)
				} else {
					this.error = resp.data.message || 'Errore nel cambio password'
				}
			} catch (err) {
				if (err.response && err.response.data) {
					this.error = firstValidationError(err, 'Errore nel cambio password')
				} else {
					this.error = 'Errore di connessione'
				}
			} finally {
				this.loading = false
			}
		}
	}
}
</script>

<style scoped>
.portal-login-bg {
	background: #ffffff;
	min-height: 100vh;
}
</style>
